// extracted by mini-css-extract-plugin
export default {"container":"ConflictTable_container__DCxj7","message":"ConflictTable_message__DIcjd"};